import {ErrorBoundary} from "components/widgets/ErrorBoundary";
import * as React from "react";
import {observable} from "mobx";
import {observer} from "mobx-react";
import './UserAvatarEditor.pcss';

import AvatarEditor from "components/widgets/AvatarEditor";

interface Props {
  setData:(data:Blob|null)=>void;
  hideTitleAndDescription?:boolean;
  existingAvatarURL:string|null;
  onClear?: () => void;
}

@observer
export class UserAvatarEditor extends React.Component<Props> {
  @observable image:any|null;
  @observable existingAvatarURL:string;

  constructor(props) {
    super(props);
    this.existingAvatarURL = this.props.existingAvatarURL||'';
  }

  render() {
    const imageState = this.image!=null;
    return (
      <div className={"userAvatarEditor"}>
        {!this.props.hideTitleAndDescription &&
          <>
            <label htmlFor={"avatar"}>Photo/Avatar</label>
            <p>Upload a photo to make interacting with others more fun!</p>
          </>
        }
        <ErrorBoundary errorMessage={"Avatar upload and modification is not behaving properly in your browser. Please report this problem to strive@well-concepts.com"}>
          <AvatarEditor
            outputSize={512}
            imageUrl={this.existingAvatarURL}
            onComplete={({ dataURI, blob }) => {
              // uploadToServer(blob);       // or use the Blob directly
              //this.props.setData(this.editor ? dataURItoBlob(this.editor.getImageScaledToCanvas().toDataURL()) : null);
              this.props.setData(dataURI ? blob : null);
            }}
          />
        </ErrorBoundary>
      </div>
    );
  }

}
